export enum SeqOrderStatusEnum {
    ALL = -1,
    INCOMPLETE = 0,
    ORDER_SUBMITTED,
    RECEIVED,
    IN_PROGRESS,
    PARTIALLY_COMPLETED,
    COMPLETED,
    ACTION_REQUIRED,
    CANCELED,
    CANCELED_FROM_LIMS,
}

export enum SeqOrderActionRequiredTypeEnum {
    ORDER_SUBMITTED_AND_TUBES_ALREADY_RECEIVED = 1,
    ORDER_RECEIVED_AND_TUBES_NOT_RECEIVED = 2,
    ORDER_CANCELED_AND_REACTIONS_NOT_CANCELED = 3,
    ORDER_NOT_CANCELED_AND_ALL_REACTIONS_CANCELED = 4,
    ORDER_COMPLETED_AND_REACTIONS_NOT_COMPLETED = 5,
    ORDER_NOT_COMPLETED_AND_ALL_REACTIONS_COMPLETED = 6,
    ORDER_NOT_IN_PROGRESS_AND_REACTIONS_COMPLETED = 7,
    ORDER_CONTAINS_COMPLETED_REACTIONS_WITHOUT_RESULT = 8,
    ORDER_CONTAINS_NOT_COMPLETED_REACTIONS_WITH_RESULT = 9,
    ORDER_REQUIRES_NEW_TUBES = 10,
}

export enum SeqReactionStatusEnum {
    SUBMITTED,
    RECEIVED,
    IN_PROGRESS,
    COMPLETED,
    ACTION_REQUIRED,
    CANCELED,
    CANCELED_FROM_LIMS,
}

export enum SeqReactionActionRequiredTypesEnum {
    REACTION_COMPLETED_WITHOUT_RESULT = 1,
    REACTION_NOT_COMPLETED_WITH_RESULT = 2,
    REACTION_REQUIRES_NEW_TUBES = 3,
}
